"use client";

import { c as _c } from "react/compiler-runtime";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from "lucide-react";
import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { createContext, startTransition, use, useEffect, useOptimistic } from "react";
import { cn, getImageAspectRatioHeight, invariant } from "@/lib/utils";
import { useRouterNoRender } from "@/ui/hooks/use-router-no-render";
import { MainProductImage } from "@/ui/storefront/products/main-product-image";
import { YnsLink } from "@/ui/yns-link";
const ImageElement = t0 => {
  const $ = _c(3);
  const {
    src,
    alt
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== src) {
    t1 = <MainProductImage src={src} alt={alt} className="h-full w-auto object-contain mx-auto" />;
    $[0] = alt;
    $[1] = src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export function ProductImageModal(t0) {
  const $ = _c(73);
  const {
    images,
    alt,
    aspectRatio
  } = t0;
  let t1;
  if ($[0] !== aspectRatio) {
    t1 = getImageAspectRatioHeight(aspectRatio, 80);
    $[0] = aspectRatio;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thumbnailHeight = t1;
  console.log({
    thumbnailHeight,
    thumbnailWidth: 80,
    aspectRatio
  });
  const {
    imageIndex,
    setImageIndex
  } = useProductDetailsImageModalContext();
  let t2;
  if ($[2] !== imageIndex || $[3] !== setImageIndex) {
    t2 = index => {
      if (!index) {
        return setImageIndex(index);
      }
      if (imageIndex !== index) {
        return setImageIndex(index);
      }
    };
    $[2] = imageIndex;
    $[3] = setImageIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const changeImageIndex = t2;
  const src = imageIndex !== null && images[Number(imageIndex)];
  let t3;
  if ($[5] !== changeImageIndex) {
    t3 = () => {
      changeImageIndex(null);
    };
    $[5] = changeImageIndex;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onDismiss = t3;
  let t4;
  if ($[7] !== onDismiss) {
    t4 = () => {
      const onKeyDown = e => {
        if (e.key === "Escape") {
          onDismiss();
        }
      };
      document.addEventListener("keydown", onKeyDown);
      return () => document.removeEventListener("keydown", onKeyDown);
    };
    $[7] = onDismiss;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  if (!src) {
    return null;
  }
  let t6;
  if ($[10] !== changeImageIndex || $[11] !== images || $[12] !== src) {
    t6 = () => {
      const pos = images.indexOf(src);
      if (pos >= 0) {
        const newPos = (images.indexOf(src) - 1 + images.length) % images.length;
        changeImageIndex(newPos);
      }
    };
    $[10] = changeImageIndex;
    $[11] = images;
    $[12] = src;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handlePrevious = t6;
  let t7;
  if ($[14] !== changeImageIndex || $[15] !== images || $[16] !== src) {
    t7 = () => {
      const pos_0 = images.indexOf(src);
      if (pos_0 <= images.length - 1) {
        const newPos_0 = (images.indexOf(src) + 1) % images.length;
        changeImageIndex(newPos_0);
      }
    };
    $[14] = changeImageIndex;
    $[15] = images;
    $[16] = src;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleNext = t7;
  let t8;
  if ($[18] !== alt || $[19] !== src) {
    t8 = <div className="absolute pointer-events-none opacity-0 -z-50"><ImageElement src={src} alt={alt} /></div>;
    $[18] = alt;
    $[19] = src;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DialogPrimitive.Overlay />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("fixed inset-0 z-50 bg-neutral-100 flex flex-col animate-in fade-in");
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== alt) {
    t11 = <DialogPrimitive.Title className="sr-only">{alt}</DialogPrimitive.Title>;
    $[23] = alt;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <DialogPrimitive.Description className="sr-only" />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onDismiss) {
    t13 = () => onDismiss();
    $[26] = onDismiss;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <XIcon className="w-6 h-6" />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13) {
    t15 = <button type="button" onClick={t13} className="ml-auto text-neutral-500 hover:text-neutral-700 p-2">{t14}</button>;
    $[29] = t13;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== onDismiss) {
    t16 = e_0 => {
      if (e_0.target === e_0.currentTarget) {
        onDismiss();
      }
    };
    $[31] = onDismiss;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== alt || $[34] !== src) {
    t17 = <ImageElement src={src} alt={alt} />;
    $[33] = alt;
    $[34] = src;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== src || $[37] !== t16 || $[38] !== t17) {
    t18 = <div key={src} className="relative w-full h-full animate-in fade-in" onClick={t16}>{t17}</div>;
    $[36] = src;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== handlePrevious) {
    t19 = () => {
      handlePrevious();
    };
    $[40] = handlePrevious;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ChevronLeftIcon className="w-6 h-6" />;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19) {
    t21 = <button type="button" onClick={t19} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 hover:bg-gray-100 transition-colors">{t20}</button>;
    $[43] = t19;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== handleNext) {
    t22 = () => {
      handleNext();
    };
    $[45] = handleNext;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ChevronRightIcon className="w-6 h-6" />;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t22) {
    t24 = <button type="button" onClick={t22} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 hover:bg-gray-100 transition-colors">{t23}</button>;
    $[48] = t22;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t18 || $[51] !== t21 || $[52] !== t24) {
    t25 = <div className="grow flex items-center justify-center overflow-hidden">{t18}{t21}{t24}</div>;
    $[50] = t18;
    $[51] = t21;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== changeImageIndex || $[55] !== images || $[56] !== src || $[57] !== thumbnailHeight) {
    let t27;
    if ($[59] !== changeImageIndex || $[60] !== src || $[61] !== thumbnailHeight) {
      t27 = (image, idx) => <ProductDetailsImageLink className={cn("border-transparent border rounded-lg overflow-hidden w-20", src === image && "border-black")} style={{
        height: thumbnailHeight
      }} onClick={e_1 => {
        e_1.preventDefault();
        changeImageIndex(idx);
      }} key={idx} prefetch={true} scroll={false} image={idx}><Image src={image} alt="" width={80} height={thumbnailHeight} className="object-cover h-full w-full" sizes="80px" /></ProductDetailsImageLink>;
      $[59] = changeImageIndex;
      $[60] = src;
      $[61] = thumbnailHeight;
      $[62] = t27;
    } else {
      t27 = $[62];
    }
    t26 = images.map(t27);
    $[54] = changeImageIndex;
    $[55] = images;
    $[56] = src;
    $[57] = thumbnailHeight;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[63] !== t26) {
    t27 = <div className="flex justify-center gap-4 py-2">{t26}</div>;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t11 || $[66] !== t15 || $[67] !== t25 || $[68] !== t27) {
    t28 = <DialogPrimitive.Root open={true} modal={true}><DialogPrimitive.Portal>{t9}<DialogPrimitive.Content className={t10}>{t11}{t12}{t15}{t25}{t27}</DialogPrimitive.Content></DialogPrimitive.Portal></DialogPrimitive.Root>;
    $[65] = t11;
    $[66] = t15;
    $[67] = t25;
    $[68] = t27;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== t28 || $[71] !== t8) {
    t29 = <>{t8}{t28}</>;
    $[70] = t28;
    $[71] = t8;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  return t29;
}
const ProductDetailsImageModalContext = createContext(null);
export const ProductDetailsImageModalProvider = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  let t2;
  if ($[0] !== searchParams) {
    const spImage = searchParams.get("image");
    const idx = spImage ? Number.parseInt(spImage, 10) : null;
    t1 = useOptimistic;
    t2 = Number.isFinite(idx) ? idx : null;
    $[0] = searchParams;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const [imageIndex, setOptimisticImageIndex] = t1(t2);
  const routerNoRender = useRouterNoRender();
  let t3;
  if ($[3] !== routerNoRender || $[4] !== searchParams || $[5] !== setOptimisticImageIndex) {
    t3 = imageIndex_0 => {
      startTransition(() => {
        setOptimisticImageIndex(imageIndex_0);
        const params = new URLSearchParams(searchParams);
        if (imageIndex_0 !== null) {
          params.set("image", imageIndex_0.toString());
        } else {
          params.delete("image");
        }
        routerNoRender.replace(`?${params}`);
      });
    };
    $[3] = routerNoRender;
    $[4] = searchParams;
    $[5] = setOptimisticImageIndex;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const setImageIndex = t3;
  let t4;
  if ($[7] !== imageIndex || $[8] !== setImageIndex) {
    t4 = {
      imageIndex,
      setImageIndex
    };
    $[7] = imageIndex;
    $[8] = setImageIndex;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== t4) {
    t5 = <ProductDetailsImageModalContext value={t4}>{children}</ProductDetailsImageModalContext>;
    $[10] = children;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export const useProductDetailsImageModalContext = () => {
  const ctx = use(ProductDetailsImageModalContext);
  invariant(ctx, "useProductDetailsImageModalContext must be used within a ProductDetailsImageModalProvider");
  return ctx;
};
export const ProductDetailsImageLink = t0 => {
  const $ = _c(10);
  let image;
  let props;
  if ($[0] !== t0) {
    ({
      image,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = image;
    $[2] = props;
  } else {
    image = $[1];
    props = $[2];
  }
  const ctx = useProductDetailsImageModalContext();
  const searchParams = useSearchParams();
  const newParams = new URLSearchParams(searchParams);
  newParams.set("image", image.toString());
  const t1 = `?${newParams}`;
  let t2;
  if ($[3] !== ctx || $[4] !== image) {
    t2 = e => {
      e.preventDefault();
      ctx.setImageIndex(image);
    };
    $[3] = ctx;
    $[4] = image;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t3 = <YnsLink {...props} href={t1} onClick={t2} />;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};